import { FC, PropsWithChildren } from 'react';

import { TTitleContext } from '@models/Title';

import TitleContext from './context';

type TitleContextProviderProps = PropsWithChildren<TTitleContext>;

const TitleContextProvider: FC<TitleContextProviderProps> = ({ children, ...titleContext }) => (
  <TitleContext.Provider value={{ ...titleContext }}>{children}</TitleContext.Provider>
);

export default TitleContextProvider;
